import { mockData as chatData } from '@web/lib/demo/data/chatEvents';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { ChatEventActionEnum } from '@workalizer/shared';
import { ChatRoomMessagePostedTypeEnum, processChatAnalytic } from '@workalizer/shared/services/processChatAnalytic';
import { isChatSpaceRoomType } from '@workalizer/shared/utils';
export var chatAnalytic = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var data = filterData(chatData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'action',
            value: ChatEventActionEnum.CHAT_MESSAGE_POSTED,
            operator: 'eq'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]);
    var events = data.map(function (item) { return ({
        date: item.date,
        count: 1,
        room_type_group: isChatSpaceRoomType(item.room.type)
            ? ChatRoomMessagePostedTypeEnum.MESSAGE_POSTED_IN_SPACE
            : ChatRoomMessagePostedTypeEnum.MESSAGE_POSTED
    }); });
    var result = processChatAnalytic(events, new Date(input.dateFrom), new Date(input.dateTo), input.groupBy);
    return result;
};
